import page from '../blogs/[slug]';

export default page;
